import { FILTER_AXES } from '../../contexts/inventoryFilterAxes';

/**
 * FilterChip — single active filter chip in the rail.
 *
 * Renders [icon] [Axis: Value] [✕]. Click body → edit (opens picker
 * scoped to this axis). Click ✕ → remove. Backspace/Delete while focused
 * on the chip also removes it.
 *
 * Registry-driven: defaults to the inventory FILTER_AXES; pass `axes` to reuse
 * the chip for a different axis set (e.g. the witness rail).
 *
 * Props:
 *   filter      — { axis, value }
 *   axes        — axis registry object (defaults to FILTER_AXES)
 *   onEdit      — (axis) => void
 *   onRemove    — (axis, value) => void
 */
export default function FilterChip({ filter, axes = FILTER_AXES, onEdit, onRemove }) {
  const def = axes[filter.axis];
  if (!def) return null;

  const valueLabel = def.formatValue ? def.formatValue(filter.value) : filter.value;

  return (
    <span className="filter-chip-active" role="group">
      <button
        type="button"
        className="filter-chip-active-body"
        onClick={() => onEdit?.(filter.axis)}
        onKeyDown={e => {
          if (e.key === 'Backspace' || e.key === 'Delete') {
            e.preventDefault();
            onRemove?.(filter.axis, filter.value);
          }
        }}
        title={`${def.label}: ${valueLabel} — click to change`}
      >
        <span className="filter-chip-active-icon">{def.icon}</span>
        <span className="filter-chip-active-axis">{def.label}:</span>
        <span className="filter-chip-active-value">{valueLabel}</span>
      </button>
      <button
        type="button"
        className="filter-chip-active-x"
        onClick={() => onRemove?.(filter.axis, filter.value)}
        aria-label={`Remove ${def.label} filter`}
      >
        ✕
      </button>
    </span>
  );
}
